var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopHomeButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#4073F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0859 35.3116C48.8227 34.4517 47.177 34.4517 45.9138 35.3116L36.3411 41.8283C35.2949 42.5405 34.6665 43.7396 34.6665 45.0236V57.4932C34.6665 59.614 36.3502 61.3334 38.4272 61.3334H43.8973C44.4637 61.3334 44.9229 60.8645 44.9229 60.286V53.3039C44.9229 52.3398 45.6882 51.5583 46.6323 51.5583H49.3674C50.3114 51.5583 51.0768 52.3398 51.0768 53.3039V60.286C51.0768 60.8645 51.536 61.3334 52.1024 61.3334H57.5725C59.6495 61.3334 61.3332 59.614 61.3332 57.4932V45.0236C61.3332 43.7396 60.7048 42.5405 59.6585 41.8283L50.0859 35.3116Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopHomeButton);
export default __webpack_public_path__ + "static/media/top_home_button.38176c0945821a98d5696c34a418557d.svg";
export { ForwardRef as ReactComponent };